module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += 'define("resources/tools", function(){\nreturn {\n    "Bunsen_Burner": {\n        name: "Bunsen_Burner",\n        icon: "styles/icons/bunsenBurner.svg",\n        template: "app/scripts/templates/bunsenBurner.ejs",\n        toolClass: "bunsen",\n        contactPoint: [18, 0]\n    },\n    "Scale": {\n        name: "Scale",\n        icon: "styles/icons/scale.svg",\n        template: "app/scripts/templates/scale.ejs",\n        toolClass: "scale",\n        contactPoint: [80, 35]\n    }\n}\n});\n';

}
return __p
}